//------------------------------------------------------------------------------
// name: index.tsx
// author: mudas
// created: 2025/11/13
//------------------------------------------------------------------------------

import { useEffect } from 'react';
import { useLoginNext, isOutPlatform, decodeNextPath } from 'common/hooks';
import { openURL } from 'common/utils';
import Cookies from 'js-cookie';

import { LoadingOutlined } from '@ant-design/icons';

// openId登录回调，用于签署协议和状态判断
const OpenIdLogin = () => {
  const { agreement, toNext } = useLoginNext();

  // --------------------------------------------------------------------------
  //
  // Class methods
  //
  // --------------------------------------------------------------------------

  const handleCorpLogin = () => {
    const search = new URLSearchParams(window.location.search);
    const RBAC_TOKEN = search.get('RBAC_TOKEN');
    const RBAC_USER = search.get('RBAC_USER');

    if (RBAC_TOKEN && RBAC_USER) {
      Cookies.set('RBAC_TOKEN', RBAC_TOKEN, { path: '/', domain: '.tiangong.yl.163.com' });
      Cookies.set('RBAC_USER', RBAC_USER, { path: '/', domain: '.tiangong.yl.163.com' });
    }
  };

  const login = async () => {
    const params = new URLSearchParams(window.location.search);
    const next = params.get('next');
    const decodeNext = next ? decodeNextPath(next) : '';

    handleCorpLogin();
    await agreement();

    if (isOutPlatform(params)) {
      openURL(decodeNext, '_self');
    } else {
      await toNext();
    }
  };

  useEffect(() => {
    login();
  }, []);

  return (
    <div className="flex-column-center justify-center h-68vh min-h-300px gap-lg">
      <LoadingOutlined className="text-size-6 color-primary" />
      登录中, 请稍后
    </div>
  );
};
export default OpenIdLogin;
